import { render, staticRenderFns } from "./VVPStudentSpecificIcardPrint.vue?vue&type=template&id=92ba1f24&scoped=true&"
import script from "./VVPStudentSpecificIcardPrint.vue?vue&type=script&lang=js&"
export * from "./VVPStudentSpecificIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./VVPStudentSpecificIcardPrint.vue?vue&type=style&index=0&id=92ba1f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ba1f24",
  null
  
)

export default component.exports